var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:{ 'navbar-burger': true, burger: true, 'is-active': _vm.activeNav },attrs:{"role":"button","aria-label":"menu","aria-expanded":"false"},on:{"click":function($event){return _vm.toggleNav()}}},[_c('span',{attrs:{"aria-hidden":"true"}}),_c('span',{attrs:{"aria-hidden":"true"}}),_c('span',{attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }